import { lazy } from 'react';
import { DealViewExtensions } from '@ayocore/erp/crm/client/components/Deals/views/DealViewExtensions';
import { ELITA_DEAL_TYPES } from '../../constants';
import { DuplicateElitaOrderButton } from '../components/DuplicateElitaOrderButton';

const ElitaOrderRowsPanel = lazy(() => import('../components/ElitaOrderRowsPanel'));

/**
 * Регистрирует расширения elita для DealView.
 * Заменяет вкладку "Позиции" своей реализацией для сделок типа ELITA_ORDER.
 *
 * Вызывается один раз из bootstrap.ts до инициализации навигации.
 */
export function registerElitaDealViewExtensions(): void {
  // Заменяем вкладку "Позиции" своей реализацией
  DealViewExtensions.tabs.register(({ deal, reload }) => {
    if (deal.deal_type?.slug !== ELITA_DEAL_TYPES.ORDER) return null;

    return {
      value: 'elita-rows',
      label: 'Сорочки и коробки',
      overrides: 'rows',
      content: <ElitaOrderRowsPanel deal={deal} onReload={reload} />,
    };
  });

  // Скрываем вкладки "Счета" и "Расходы" — не применимы к КП
  DealViewExtensions.tabs.register(({ deal }) => {
    if (deal.deal_type?.slug !== ELITA_DEAL_TYPES.ORDER) return null;
    return {
      value: 'hide-invoices',
      label: '',
      overrides: 'invoices',
      hidden: true,
      content: null,
    };
  });

  DealViewExtensions.tabs.register(({ deal }) => {
    if (deal.deal_type?.slug !== ELITA_DEAL_TYPES.ORDER) return null;
    return {
      value: 'hide-expenses',
      label: '',
      overrides: 'expenses',
      hidden: true,
      content: null,
    };
  });

  // Скрываем панель событий — не применима к КП
  DealViewExtensions.hideEventList.register(({ deal }) => {
    return deal.deal_type?.slug === ELITA_DEAL_TYPES.ORDER;
  });

  // Кнопка «Создать по образцу» в шапке — только для ELITA_ORDER
  DealViewExtensions.headerActions.register(({ deal }) => {
    if (deal.deal_type?.slug !== ELITA_DEAL_TYPES.ORDER) return null;
    return <DuplicateElitaOrderButton dealId={deal.id as number} />;
  });
}
